import { FailureCode } from './failure-code.model';

export class WorkOrderRequestSub {
  acceptedAndPaid: boolean = null;
  authorizationCodes: string = null;
  authorizationComments: string = null;
  authorizationNumber: string = null;
  batteryCode: string = null;
  batteryProrata: string = null;
  batteryWarrantyCode: string = null;
  cause: string = null;
  claimNarrative: string = null;
  dealerInstalled: string = null;
  diagnosticTroubleCode: string = null;
  dispositionStatus: string = null;
  embedded?: WorkOrderRequestSubEmbed = null;
  failureCodeId: string = null;
  id: number = null;
  labourOpComment: string = null;
  labourCode: string = null;
  labourDescription: string = null;
  mailReceiptNumber: string = null;
  mainManufacturerVehicle: string = null;
  majorDamageIndicator: string = null;
  oemClaimNumber: string = null;
  oemClaimVersionNumber: number = null;
  originalInvoiceNumber: string = null;
  originalOdometer: number = null;
  originalRepairDate: Date = null;
  reconLinkRef: string = null;
  submitFlag: string = null;
  taxInidicator: string = null;
  vehicleAreaCodeId: number = null;
  vehicleDamageCodeId: number = null;
  vehicleDamangeSeverityCodeId: number = null;
  waiveDeductible: boolean = null;
  warrantyAmount: number = null;
  warrantyAuthorizationTypeId: number = null;
  warrantyCase: number = null;
  warrantyMaintenance: boolean = null;
  warrantyNetItemTypeCodeId: number = null;
  warrantySubmissionTypeId: string = null;
  workOrderId: number = null;
  workOrderSequence: number = null;

  constructor(obj?: WorkOrderRequestSub) {
    if (obj) {
      Object.assign(this, obj);
    }
  }
}

class WorkOrderRequestSubEmbed {
  failureCode?: FailureCode = null;
}
